import React from 'react';
import './Navbar.css'; // We'll create this for custom styles
import { Link } from 'react-router-dom';

const Navbar = () => {
  // Function to close navbar on mobile after clicking a link
  const closeNavbar = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('.navbar-collapse');

    // Check if navbar is expanded (visible on mobile)
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarToggler?.click(); // Trigger the toggle button to close
    }
  };

  return (
    <>
      {/* Top Banner */}


      {/* Navbar */}
      <nav className="navbar navbar-expand-lg sticky-top shadow-sm bg-white">
        <div className="container">
          <Link className="navbar-brand fw-bold fs-3 d-flex align-items-center" to="/" onClick={closeNavbar}>
            <img
              src="/logo.png"
              alt="SpireNest Logo"
              style={{
                height: '40px',
                width: 'auto',
                marginRight: '12px'
              }}
            />
            SpireNest
          </Link>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item"><Link className="nav-link active fw-bold" to="/" onClick={closeNavbar}>Home</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/about" onClick={closeNavbar}>About</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/products" onClick={closeNavbar}>Products</Link></li>
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown">Services</button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/netsuite/services" onClick={closeNavbar}>NetSuite Managed Services</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/staffing" onClick={closeNavbar}>NetSuite Staffing</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/implementation" onClick={closeNavbar}>NetSuite Implementation</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/erp" onClick={closeNavbar}>NetSuite ERP</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/support" onClick={closeNavbar}>NetSuite Support</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/financial" onClick={closeNavbar}>NetSuite Financial  </Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/crm" onClick={closeNavbar}>NetSuite CRM</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/services/ecommerce" onClick={closeNavbar}>NetSuite Ecommerce</Link></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown">Industries</button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/netsuite/industries/it-software" onClick={closeNavbar}>IT & Software</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/industries/wholesale-distribution" onClick={closeNavbar}>Wholesale & Distribution</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/industries/manufacturing" onClick={closeNavbar}>Manufacturing</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/industries/retail-ecommerce" onClick={closeNavbar}>Retail & Ecommerce</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/industries/healthcare" onClick={closeNavbar}>Healthcare</Link></li>
                  <li><Link className="dropdown-item" to="/netsuite/industries/finance-accounting" onClick={closeNavbar}>Finance & Accounting</Link></li>
                </ul>
              </li>
              <li className="nav-item"><Link className="nav-link" to="/careers" onClick={closeNavbar}>Careers</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/blog" onClick={closeNavbar}>Blog</Link></li>
             
              
            </ul>

            {/* Search & CTA */}
            <div className="d-flex align-items-center ms-3">

              <button className="btn btn-dark d-flex align-items-center px-3 py-2" onClick={closeNavbar}>
              <Link className="nav-link" to="/contact">Contact Us</Link>

              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
